import React from 'react';
// import ReactApexChart from 'react-apexcharts';

class LineAreaChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      chartData: [],
      chartOptions: {},
    };
  }

  componentDidMount() {
    this.setState({
      chartData: this.props.chartData,
      chartOptions: this.props.chartOptions,
    });
  }

  render() {
    return (
      <iframe
        src="https://codesandbox.io/embed/nice-water-1v4hzb?fontsize=14&hidenavigation=1&initialpath=%2Fline-chart-2&theme=dark&view=preview"
        width="100%"
        height="200px"
        ms="-15px"
        overflow="hidden"
      ></iframe>
      // <ReactApexChart
      //   options={this.state.chartOptions}
      //   series={this.state.chartData}
      //   type="area"
      //   width="100%"
      //   height="100%"
      // />
    );
  }
}

export default LineAreaChart;
